import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-package-purchase-modal',
  templateUrl: './package-purchase-modal.page.html',
  styleUrls: ['./package-purchase-modal.page.scss'],
})
export class PackagePurchaseModalPage implements OnInit {

  public packageToDisplay: string;
  public annual: string;
  public annualMonthly: string;
  public reporting: string;
  public distribution: string;
  public file: string;
  public bundle: string;

  constructor(
    public modalController: ModalController
  ) { }

  ngOnInit() {
  }

  cancelModal() {
    this.modalController.dismiss();
  }

}
